<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="60rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">{{ popTitle }}</div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>
      <!--content-->
      <v-card-text>
        <div class="dropdown-group ty01">
          <div class="form-group col-ty">
            <div class="form-row02"
                 v-for="(item, i) in items"
                 :key="i">
              <c-Input :placeholder="t('message.shiftWork')" v-model="item.shiftName" :name="'shiftName'" class="size03"/>
              <c-btn02 :btnText="t('message.delete')" @click.stop="deleteRow(i)"/>
            </div>
          </div>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class="d-flex justify-end pop-bottom-bg"><!--pop-bottom-bg-->
        <c-btn02 :btnText="t('message.add')" :btnType="'button'" class="" @click.stop="addRow()"/>
        <c-btn01 v-bind="btnSave" @click="handleForm"/>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </v-dialog>
</template>

<script setup lang="ts">
import {ref, computed} from 'vue'
import CompanyService from "@/services/company.service";
import utils from "@/common/Utils";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//popup close event
const emit = defineEmits(['close', 'confirm'])
const props = defineProps(['popTitle'])
const dialog = defineModel()

//bind
const snackbar = ref(false)
const snackText = ref('')
const items = ref([])

//ui
const btnSave = computed(() =>({
  btnText: t('message.confirm'),
  btnType: 'submit'
}))

//hook
onBeforeUpdate (()=>{
  items.value = []
})

onUpdated(() => {
  getData()
})

//function
function getData(){
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx: companyIdx,
  }

  CompanyService.getCompanyShiftList(params).then(
    (response) => {
      items.value = response.result
      if(response.result.length == 0)
        addRow()
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function addRow(){
  let row = {
    shiftName: '',
    idx: '',
  }
  items.value.push(row)
}

function deleteRow(index){
  items.value.splice(index, 1)
}

function handleForm(){
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    let shiftArr = []
    items.value.forEach(function (item){
      shiftArr.push(item.shiftName)
    })
    let params = {
      companyIdx: companyIdx,
      shiftList: shiftArr
    }

    CompanyService.insertCompanyShift(params).then(
      (response) => {
        emit('confirm', 'update shift')
        emit('close', 'refresh')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

</script>


<style lang="scss">

</style>
